export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',

  // Xudo (X Role)
  'menu.xudo': 'X CENTER',
  'menu.xudo.xhub': '中心 (Hubs)',
  'menu.xudo.xvendor': '供应商',
  'menu.xudo.game': '游戏',
  'menu.xudo.players': '玩家列表',
  'menu.xudo.transactions': '交易列表',
  'menu.xudo.control-center': '控制中心',
  'menu.xudo.social-platform-automation': '社交平台自动化',
  'menu.org.ggrtiers': 'ตั้งค่า GGR Tier',
  'menu.org.ggrtiers-detail': 'Information',

  // Org Dashboard
  'menu.org': 'Dashboard',
  'menu.org.home': '首页',
  'menu.xudo.member': '所有者',
  'menu.xudo.interface-events': '接口事件',
  'menu.org.gsessions': '游戏会话',
  'menu.org.vendor': '供应商',
  'menu.org.game': '游戏',
  'menu.org.analysis': '分析',
  'menu.org.ggr-tier-config': 'GGR层级配置',

  // Management
  'menu.management': '管理',
  'menu.management.site-list': '站点列表',
  'menu.management.players': '玩家',
  'menu.management.players.detail': '玩家详情',

  'menu.management.vendor': '供应商',
  'menu.management.game': '游戏',
  'menu.management.game.category': '游戏分类',
  'menu.management.game.all': '全部',
  'menu.management.game.electronic': '电子',
  'menu.management.game.slot': '老虎机',
  'menu.management.game.table': '桌面游戏',
  'menu.management.game.live': '真人视讯',
  'menu.management.game.card': '牌',
  'menu.management.game.poker': '扑克',
  'menu.management.game.arcade': '街机',
  'menu.management.game.animal': '赛马',
  'menu.management.game.lottery': '彩票',
  'menu.management.game.fish': '捕鱼游戏',
  'menu.management.game.sport': '体育',
  'menu.management.game.esport': '电子竞技',
  'menu.org.brand': '品牌与主题',
  'menu.management.contents': '内容',
  'menu.management.player-finance-operations': 'Processing Transactions',
  'menu.management.payment-methods': '支付方式',
  'menu.settings.fund': '财务',
  'menu.settings.finance': '财务',
  'menu.settings.social-links': '社交媒体链接',
  'menu.settings.payment-methods': '支付方式',
  'menu.management.provision': '配置网站',
  'menu.management.provision-status': '配置状态',

  // Dashboard
  'menu.dashboard': '仪表盘',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.gsessions': '游戏会话',
  'menu.dashboard.vendor': '供应商',
  'menu.dashboard.game': '游戏',
  'menu.dashboard.workplace': '工作台',
  'menu.dashboard.control-center': '控制中心',

  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '账户',
  'menu.settings': '账户与设置',
  'menu.settings.account': '账户',
  'menu.account.settings': '账户设置',
  'menu.settings.api-config': 'API配置',
  'menu.settings.typography': '字体排版',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',

  // Micro Frontend
  'micro.loading': '正在加载微应用...',
  'micro.error.title': '加载微应用失败',
  'micro.error.description':
    '请检查是否在 config/config.ts 中启用了 qiunkun 插件',
  'micro.notReady': '微前端未就绪',

  // Provision Page
  'provision.title': '配置新站点',
  'provision.step.selectTemplate': '选择模板',
  'provision.step.configure': '配置站点',
  'provision.step.provision': '配置',
  'provision.template.title': '选择模板',
  'provision.template.selectRequired': '请选择一个模板',
  'provision.template.selected': '已选择',
  'provision.template.estimatedTime': '预计时间',
  'provision.config.title': '站点配置',
  'provision.config.siteName': '站点名称',
  'provision.config.siteName.placeholder': 'my-awesome-site',
  'provision.config.siteName.required': '请输入站点名称',
  'provision.config.siteName.pattern': '仅允许小写字母、数字和连字符',
  'provision.config.siteName.min': '最少3个字符',
  'provision.config.environment': '环境',
  'provision.config.environment.sandbox': '沙盒 (测试)',
  'provision.config.environment.uat': 'UAT (预发布)',
  'provision.config.environment.production': '生产 (正式)',
  'provision.config.currency': '默认货币',
  'provision.config.theme': '主题',
  'provision.config.theme.default': '默认',
  'provision.config.theme.dark': '深色模式',
  'provision.config.theme.light': '浅色模式',
  'provision.ready.title': '准备配置',
  'provision.ready.description': '您的站点将使用以下配置创建：',
  'provision.info.title': '信息',
  'provision.info.template': '模板：预配置的数据库架构',
  'provision.info.environment': '环境：隔离的部署环境',
  'provision.info.provisioning': '配置：使用 Neon 自动设置',
  'provision.btn.previous': '上一步',
  'provision.btn.next': '下一步',
  'provision.btn.provision': '配置站点',
  'provision.success.title': '站点配置成功！',
  'provision.success.description': '您的站点 {siteName} 已准备就绪！',
  'provision.success.connection.title': '连接详情',
  'provision.success.connection.host': '数据库主机',
  'provision.success.connection.dbName': '数据库名称',
  'provision.success.connection.uri': '连接 URI',
  'provision.success.connection.copy': '点击复制完整 URI',
  'provision.success.btn.management': '前往站点管理',
  'provision.status.started': '配置已开始！',
  'provision.status.failed': '配置站点失败',
  'provision.status.success': '站点配置成功！',

  // Quota Page
  'fund.title': '配额与账单',
  'fund.tab.purchase': '购买配额',
  'fund.tab.history': '交易历史',
  'fund.balance.title': '可用余额',
  'fund.balance.pending': '待处理',
  'fund.balance.totalDeposited': '总存入',
  'fund.balance.totalSpent': '总支出',
  'fund.howItWorks.title': '使用方法',
  'fund.howItWorks.step1': '选择配额套餐',
  'fund.howItWorks.step2': '输入您的站点名称',
  'fund.howItWorks.step3': '使用加密货币支付（USDT、BTC、ETH）',
  'fund.howItWorks.step4': '系统自动配置站点',
  'fund.package.title': '选择配额套餐',
  'fund.siteConfig.title': '站点配置',
  'fund.siteConfig.name': '站点名称',
  'fund.siteConfig.name.placeholder': 'my-awesome-site',
  'fund.siteConfig.name.hint': '这将是您站点的唯一标识符',
  'fund.siteConfig.package': '套餐',
  'fund.siteConfig.fund': '配额',
  'fund.siteConfig.price': '价格',
  'fund.siteConfig.discount': '折扣',
  'fund.purchase.btn': '购买 {price}',
  'fund.table.date': '日期',
  'fund.table.type': '类型',
  'fund.table.fund': '配额',
  'fund.table.amount': '金额',
  'fund.table.status': '状态',
  'fund.table.site': '站点',
  'fund.warning.selectPackage': '请选择配额套餐',
  'fund.warning.enterSiteName': '请输入站点名称',

  // Payment Methods
  'menu.settings.paymentMethods': '支付方式',
  'pages.settings.paymentMethods.title': '支付方式',
  'pages.settings.paymentMethods.description': '配置可用于存款和取款的支付方式',
  'pages.settings.paymentMethods.saveSuccess': '支付方式保存成功',
  'pages.settings.paymentMethods.saveError': '支付方式保存失败',
  'pages.settings.paymentMethods.enabled': '启用',
  'pages.settings.paymentMethods.disabled': '禁用',
  'pages.settings.paymentMethods.minAmount': '最小金额',
  'pages.settings.paymentMethods.maxAmount': '最大金额',
  'pages.settings.paymentMethods.depositFee': '存款手续费 (%)',
  'pages.settings.paymentMethods.withdrawalFee': '取款手续费 (%)',
  'pages.settings.paymentMethods.apiKey': 'API密钥',
  'pages.settings.paymentMethods.merchantId': '商户ID',
  'pages.settings.paymentMethods.save': '保存更改',
  'pages.settings.paymentMethods.reset': '重置',
  'pages.settings.paymentMethods.creditDebit': '信用卡/借记卡',
  'pages.settings.paymentMethods.ewallets': '电子钱包',
  'pages.settings.paymentMethods.bankTransfer': '银行转账',
  'pages.settings.paymentMethods.cryptocurrency': '加密货币',
  'pages.settings.paymentMethods.mobilePayment': '移动支付',
  'pages.settings.paymentMethods.regional': '地区支付方式',
  'pages.settings.paymentMethods.localTransfer': '本地转账',
  'pages.settings.paymentMethods.ewallet': '电子钱包',
  'pages.settings.paymentMethods.card': '银行卡支付',
  'menu.virtual-world': '虚拟世界',
  'menu.virtual-world.items': '消耗道具',
  'menu.virtual-world.gifts': '礼物',
  'menu.virtual-world.promotions': '促销活动',
  'menu.reports': '报表',
  'menu.reports.finance': '财务报表',
  'menu.reports.members': '会员报表',
  'menu.reports.games': '游戏报表',
  'menu.reports.bonus': '奖金报表',
};
